import { MuiTimeSeriesOptions } from "./TimeSeriesMuiChart";
import { TimeAxisScaleType } from "./TimeAxisScaleType";

const defaultScaleType = "time";
export const resolveTimeAxisScaleType = (
  timeSeriesOptions: Array<MuiTimeSeriesOptions> | undefined
): TimeAxisScaleType => {
  if (timeSeriesOptions === undefined) {
    return defaultScaleType;
  }
  return defaultScaleType;
};
